<div class="warehouse-page">
  <header class="page-header">
    <div>
      <h2>Склады</h2>
      <p>Управление складами и стоимостью текущих остатков</p>
    </div>

    <button mat-flat-button color="primary" type="button" (click)="startCreate()">
      <mat-icon>add</mat-icon>
      Добавить склад
    </button>
  </header>

  <mat-card class="list-card">
    <div class="list-toolbar">
      <mat-form-field appearance="outline">
        <mat-label>Поиск</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [formControl]="searchControl" placeholder="Название, город или ID" />
        <button
          *ngIf="searchControl.value"
          mat-icon-button
          matSuffix
          type="button"
          aria-label="Очистить поиск"
          (click)="searchControl.reset('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <span class="warehouse-count">Всего: {{ filteredWarehouses.length }}</span>
    </div>

    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

    <div class="table-scroll" *ngIf="filteredWarehouses.length">
      <table mat-table [dataSource]="filteredWarehouses">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let warehouse">{{ warehouse.id }}</td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Название</th>
          <td mat-cell *matCellDef="let warehouse">
            <strong>{{ warehouse.description }}</strong>
          </td>
        </ng-container>

        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef>Город</th>
          <td mat-cell *matCellDef="let warehouse">
            {{ warehouse.city?.description || '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="inventoryValue">
          <th mat-header-cell *matHeaderCellDef>Стоимость остатка</th>
          <td mat-cell *matCellDef="let warehouse" class="inventory-value">
            {{ supportService.formatMoney(warehouse.inventoryValue) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let warehouse" class="actions-cell">
            <button
              mat-icon-button
              color="primary"
              type="button"
              title="Открыть карточку"
              [disabled]="deletingId === warehouse.id"
              (click)="startEdit(warehouse)"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              color="warn"
              type="button"
              title="Удалить"
              [disabled]="deletingId === warehouse.id"
              (click)="remove(warehouse)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div class="empty-state" *ngIf="!loading && !filteredWarehouses.length">
      <mat-icon>warehouse</mat-icon>
      <h3>{{ searchControl.value ? 'Склады не найдены' : 'Складов пока нет' }}</h3>
      <p>
        {{
          searchControl.value
            ? 'Измените запрос или очистите поиск'
            : 'Добавьте первый склад, чтобы использовать его в документах'
        }}
      </p>
    </div>
  </mat-card>
</div>
